import actions from "./actions";
import state from "./states"
import mutations from "./mutations";

const AdminCampaignPaymentModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminCampaignPaymentModule;